// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopupItem__container-ad7f6c {
  flex-shrink: 0;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-inline-start: 24px;
  padding-inline-end: 20px;
}

.PopupItem__small-container-fb1dc2 {
  flex-shrink: 0;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 16px;
}

.PopupItem__interactive-b4c298 {
  cursor: pointer;
}

.PopupItem__interactive-b4c298:hover {
  background-color: var(--base-17);
}

@supports (display: block) {
  .PopupItem__interactive-b4c298:focus-visible {
    background-color: var(--base-17);
  }
}
.PopupItem__interactive-b4c298:focus-within {
  background-color: var(--base-17);
}

.PopupItem__interactive-b4c298:active {
  background-color: var(--base-30);
}

.PopupItem__active-b4044c {
  background-color: var(--base-20);
}

.PopupItem__card-ab092c {
  flex: 1;
  margin-inline-end: var(--indent-12px);
}

.PopupItem__hint-ff958a {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/PopupItem/PopupItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,wBAAA;AACF;;AAEA;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE;IACE,gCAAA;EACF;AACF;AAEA;EACE,gCAAA;AAAF;;AAGA;EACE,gCAAA;AAAF;;AAGA;EACE,gCAAA;AAAF;;AAGA;EACE,OAAA;EACA,qCAAA;AAAF;;AAGA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;AAAF","sourcesContent":[".container {\n  flex-shrink: 0;\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  padding-inline-start: 24px;\n  padding-inline-end: 20px;\n}\n\n.small-container {\n  flex-shrink: 0;\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 4px 16px;\n}\n\n.interactive {\n  cursor: pointer;\n}\n\n.interactive:hover {\n  background-color: var(--base-17);\n}\n\n@supports (display: block) {\n  .interactive:focus-visible {\n    background-color: var(--base-17);\n  }\n}\n\n.interactive:focus-within {\n  background-color: var(--base-17);\n}\n\n.interactive:active {\n  background-color: var(--base-30);\n}\n\n.active {\n  background-color: var(--base-20);\n}\n\n.card {\n  flex: 1;\n  margin-inline-end: var(--indent-12px);\n}\n\n.hint {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PopupItem__container-ad7f6c`,
	"small-container": `PopupItem__small-container-fb1dc2`,
	"smallContainer": `PopupItem__small-container-fb1dc2`,
	"interactive": `PopupItem__interactive-b4c298`,
	"active": `PopupItem__active-b4044c`,
	"card": `PopupItem__card-ab092c`,
	"hint": `PopupItem__hint-ff958a`
};
module.exports = ___CSS_LOADER_EXPORT___;
